/* Dev-only logger. In production builds we no-op to keep console clean. */
const IS_DEV = process.env.NODE_ENV !== "production";

export const logger = {
  warn(...args) { if (IS_DEV) console.warn(...args); },
  error(...args) { if (IS_DEV) console.error(...args); },
  info(...args) { if (IS_DEV) console.info(...args); },
  debug(...args) { if (IS_DEV) console.debug(...args); },
};
